import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/renunciareceita/listar/form_edit'
import Head from '../../../../components/head'


function EditarRenunciaReceitaScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Renúncia de Receita" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarRenunciaReceitaScreen;